<template>
  <v-layout row wrap v-show="elementoPai.premioApoliceAnterior.opened" align-center justify-center>
    <v-flex xs12 sm8 md8 lg6>
      <v-card style="padding: 15px;">
        <v-layout row wrap align-center justify-center>
          <v-card-text>
            <v-form>
              <v-flex xs12 class="text-xs-center">
                <h2 class="primary--text">Olá, Bem-Vindo!</h2>
                <br>
                <span>Vamos começar a cotação do seguro.</span>
              </v-flex>
              <br>
              <v-flex xs12 class="text-xs-center">
                <span class="primary--text"><b>Possui apólice de seguro de cargas?*</b></span>
                <v-radio-group id="apoliceSeguroRadioGroup" v-model="premioApoliceAnterior.apoliceAnterior" row class="justify-center">
                  <v-radio id="apoliceSeguroSimRadio" label="Sim" color="primary" :value="true"></v-radio>
                  <v-radio id="apoliceSeguroNaoRadio" label="Não" color="primary" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
              <br>
              <v-flex xs12 v-show="premioApoliceAnterior.apoliceAnterior" class="text-xs-center">
                <span class="primary--text"><b>Qual o valor do prêmio?*</b></span>
                <br>
                <v-layout justify-center>
                  <v-flex xs12 sm6 md6>
                    <v-text-field id="valorPremioText" ref="valorPremioText"
                      label="Valor do prêmio*"
                      :rules="formRulesComputed.premioApoliceAnterior.valorPremio(premioApoliceAnterior.apoliceAnterior, premioApoliceAnterior.valorPremio)"
                      v-model="valoresFormatados.valorPremio"
                      v-money="maskComputed.maskMoney">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-flex xs12 style="margin-left: 10px">
              <v-btn id="registrarApoliceAnteriorBtn" ref="registrarApoliceAnteriorBtn"
              color="secondary"
              :disabled="!formValid"
              @click="registrarPremioApoliceAnterior(premioApoliceAnterior)">Próximo</v-btn>
            </v-flex>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {VMoney} from 'v-money'
import CustomFormat from '@/helpers/custom-format'
import formRules from '@/helpers/form-rules';
import mask from "@/helpers/mask"

export default {
  name: "PremioApoliceAnterior",
  directives: {
    money: VMoney
  },
  data: function() {
    return {
      premioApoliceAnterior: {
        apoliceAnterior: null,
        valorPremio: null
      },
      valoresFormatados: {
        valorPremio: ""
      }
    }
  },
  computed: {
    elementoPai: function () {
      return this.$parent;
    },
    formRulesComputed: function() {
      return formRules;
    },
    maskComputed: function() {
      return mask;
    },
    formValid: function() {
      const self = this;
      if (self.premioApoliceAnterior) {
        return  (self.premioApoliceAnterior.apoliceAnterior == true && self.premioApoliceAnterior.valorPremio != null && self.premioApoliceAnterior.valorPremio > 0) ||
                (self.premioApoliceAnterior.apoliceAnterior == false && self.premioApoliceAnterior.valorPremio == null);
      }
    }
  },
  watch: {
    'premioApoliceAnterior.apoliceAnterior': function(newValue) {
      const self = this;
      if (newValue == false) {
        self.premioApoliceAnterior.valorPremio = null;
      } else {
        self.$refs.valorPremioText.$el.getElementsByTagName('input')[0].value = "R$ 0,00";
        self.premioApoliceAnterior.valorPremio = 0;
        self.$refs.valorPremioText.reset();
      }
    },
    'valoresFormatados.valorPremio': function (val) {
      this.premioApoliceAnterior.valorPremio = CustomFormat.removeMoneyFormat(val);
    }
  },
  methods: {
    registrarPremioApoliceAnterior: function(premioApoliceAnterior) {
      const self = this;
      self.elementoPai.premioApoliceAnterior.valor = premioApoliceAnterior;
      self.elementoPai.premioApoliceAnterior.opened = false;
      self.elementoPai.tipoCliente.opened = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/questionario/PremioApoliceAnterior.vue